import Park from './Park.vue'

export default Park
